import { type Analytics, getAnalytics } from "firebase/analytics"
import type { App, InjectionKey } from "vue"
import { isDemo } from "~/plugins/firebase"

declare module "vue" {
    interface ComponentCustomProperties {
        $analytics: Analytics
    }
}

export const analyticsKey = Symbol() as InjectionKey<Analytics>
export const analytics = {
    install: (app: App) => {
        const firebaseApp = app.config.globalProperties.$firebase
        if (!isDemo(firebaseApp)) {
            const firebaseAnalytics = getAnalytics(firebaseApp)
    
            app.provide(analyticsKey, firebaseAnalytics)
            app.config.globalProperties.$analytics = firebaseAnalytics
        }
    }
}